import React from 'react';
import { METRICS_ENTITY_TYPE_LABEL_MAP } from 'app/stores/metrics/metricsConstants';
import { Tag } from 'core/components';

const NmsPolicyEntityTypeTag = ({ entityType, intent, ...props }) => {
  const entityLabel = METRICS_ENTITY_TYPE_LABEL_MAP[entityType] || entityType;
  return (
    <Tag intent={intent || 'primary'} ellipsis={false} {...props}>
      Entity: {entityLabel}
    </Tag>
  );
};

export default NmsPolicyEntityTypeTag;
